import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getMarketingPartnerPromo } from '@apis/marketing';

import { MARKETING_CAROUSEL_CORE_CONFIGS_KEY } from '@constants/general';

import { GlobalContext } from '@context/GlobalContext';

import { useAxiosQuery, UseAxiosQueryOptions } from '@hooks/useAxiosQuery';

import { getCurrentSiteState, getLocaleState } from '@redux/selectors';

import { MarketingPartnerPromo } from '@wegoTypes/marketing/marketingPatnerPromo';

const getMarketingPartnerPromoKey = 'marketing-partner-promo';

export const useGetMarketingPartnerPromo = <TResult = MarketingPartnerPromo>(
  options?: UseAxiosQueryOptions<MarketingPartnerPromo, TResult>,
) => {
  const apiBaseUrl = API_BASE_URL;
  const locale = useSelector(getLocaleState);
  const currentSiteCode = useSelector(getCurrentSiteState);
  const { userCentricCoreConfigs } = useContext(GlobalContext);

  const marketingCarouselCoreConfig = useMemo(
    () =>
      userCentricCoreConfigs.find(
        (coreConfig) => coreConfig.key === MARKETING_CAROUSEL_CORE_CONFIGS_KEY,
      ),
    [userCentricCoreConfigs],
  );

  const isDynamicMarketingCarousel = marketingCarouselCoreConfig?.value === '1';

  return useAxiosQuery({
    queryKey: [
      getMarketingPartnerPromoKey,
      {
        locale,
        currentSiteCode: currentSiteCode.countryCode,
        isDynamicMarketingCarousel,
        userCentricCoreConfigs,
      },
    ],
    queryFn: () =>
      userCentricCoreConfigs.length > 0
        ? getMarketingPartnerPromo(
            apiBaseUrl,
            locale,
            currentSiteCode.countryCode,
            'WEB_APP',
            'DESKTOP',
            isDynamicMarketingCarousel,
          )
        : Promise.resolve({} as MarketingPartnerPromo),
    ...options,
  });
};
